import logoSvg from '../../assets/logo.svg';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-heart-pulse-line text-white text-lg"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                CoachFit
              </span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Votre coach sportif personnel à Marseille. Martin Fabrice vous accompagne dans votre transformation physique avec des séances de coaching à domicile personnalisées.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="/services" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Coaching Personnel
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Fitness & Musculation
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Nutrition & Bien-être
                </a>
              </li>
              <li>
                <a href="/services" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Yoga & Méditation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2 text-teal-400"></i>
                <span className="text-sm">10 rue Saint Eloi, 13010 Marseille</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2 text-teal-400"></i>
                <a 
                  href="mailto:fabio-coaching-sportif@hotmail.fr" 
                  className="text-sm hover:text-teal-400 transition-colors cursor-pointer"
                >
                  fabio-coaching-sportif@hotmail.fr
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-2 text-teal-400"></i>
                <a 
                  href="tel:0623818989" 
                  className="text-sm hover:text-teal-400 transition-colors cursor-pointer"
                >
                  06 23 81 89 89
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 CoachFit. Tous droits réservés.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0">
            <a href="/mentions-legales" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              Mentions légales
            </a>
            <a href="/confidentialite" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              Confidentialité
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
